"use client";

import Link from "next/link";
import { usePathname, useParams } from "next/navigation";
import { menuList } from "@/app/data/index";
import clsx from "clsx";

export default function SubMenu() {
  let pathname = usePathname();
  const { detailId } = useParams();
  pathname = detailId ? pathname.replace(`/${detailId}`, "") : pathname;

  const current = menuList.slice(1).find((menu) => {
    // console.log(usePathname() + "----", menu.link);
    return pathname.startsWith(menu.link) && pathname !== "/";
  })!;

  const menus = current?.children?.length
    ? current.children
    : menuList.slice(1);

  return (
    <div className="w-[280px] bg-[#f7f7f7]">
      <h2 className="h-[54px] text-white text-center text-[18px]/[54px] font-bold bg-[#07408e]">
        {current?.name}
      </h2>
      <ul className="py-[10px]">
        {menus.map((menu) => (
          <li
            key={menu.link}
            className={clsx(
              "group px-[10px] w-[280px] border-b-[1px] border-[#ddd]",
              {
                  "bg-[#E7F0FE]": pathname === menu.link,
              }
            )}
          >
            <Link
              href={menu.link}
              className={`h-[50px] text-[16px]/[50px] flex items-center justify-between pr-[15px] pl-[20px] hover:text-[#164fa6] hover:font-bold`}
            >
              <span
                className={clsx({
                  "text-[#164fa6]": pathname === menu.link,
                  "font-bold": pathname === menu.link,
                  //   "bg-[#E7F0FE]": pathname === menu.link,
                })}
              >
                {menu.name}
              </span>
              <div
                className={clsx(
                  "w-[14px] h-[14px] bg-no-repeat bg-center",
                  "group-hover:bg-[url('/imgs/arrow-blue.png')]",
                  {
                    "bg-[url('/imgs/arrow-blue.png')]": pathname === menu.link,
                    "bg-[url('/imgs/arrow-gray.png')]": pathname !== menu.link,
                  }
                )}
              ></div>
              {/* <Image
                src={usePathname() === menu.link ? ArrowBlue : ArrowGray}
                alt="箭头"
                width={24}
                height={24}
              ></Image> */}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
